export default "__VITE_ASSET__CDLE5H2Z__"